import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog/index';
import PreviewImage from './components/preview-image/index';
import classes from './open-image-popup.scss';
const content = mockups => {
  if (!mockups) {
    return null;
  }
  return mockups.map((variantMockups, variantIndex) => /*#__PURE__*/React.createElement("div", {
    className: classes.row,
    key: variantIndex
  }, variantMockups.map((mockupUrl, mockupIndex) => /*#__PURE__*/React.createElement(PreviewImage, {
    key: mockupIndex,
    image: mockupUrl
  }))));
};
const OpenImagePopup = ({
  reset,
  onClose,
  mockups
}) => /*#__PURE__*/React.createElement(InfoDialog, {
  subHeader: "Customer mockup",
  content: content(mockups),
  onRequestClose: e => {
    reset();
    onClose(e);
  },
  showCloseButton: true,
  titleClass: classes.imageMockupsTitle,
  closeButtonClassName: classes.closeBtn,
  bodyClassName: classes.imageMockupsBody,
  paperClassName: classes.imageMockups,
  contentClassName: classes.imageMockupsContent,
  open: true
});
export default OpenImagePopup;